import ZingerBanner from './components/ZingerBanner.jsx'
import ZingerBottom from './components/ZingerBottom.jsx'

export default function Landing() {
  return (
    <>
      <ZingerBanner />

      <section className="bg-white py-6">
        <div className="max-w-4xl mx-auto px-4 sm:px-8 md:px-16 text-center">
          <h2 className="text-2xl md:text-4xl font-extrabold mb-2 leading-tight">
            Master life one microskill at a time.
          </h2>
          <p className="text-base md:text-lg leading-snug text-gray-700">
            Build domain mastery through systematic, bottom-up development of focused, testable units.
          </p>
        </div>
      </section>

      <ZingerBottom />
    </>
  )
}
